import React from 'react';
import { validation } from '../utility';

function Select({ className, error, name, label, placeholder, value, onChange, inline, autoComplete, choices }) {
  return (
    <div className={className + ' ' + (inline ? 'error-container-inline' : 'error-container')}>
      <label htmlFor={name} className="form-label">{label}</label>
      <select autoComplete={autoComplete} className={validation('form-select', error)} name={name} id={name} aria-label={label} value={value} onChange={onChange} required>
        <option value="" disabled hidden>{placeholder}</option>
        {choices.map(choice => <option key={choice.value} value={choice.value}>{choice.text}</option>)}
      </select>
      <p className="error">{error ? '(' + error + ')' : ''}&nbsp;</p>
    </div>
  );
}

export default Select;
